export default __webpack_public_path__ + "static/media/Instagram.c228c6a0.svg";